/**
 * useCustomerImportPreview — preview server-side (até 50 itens) de um job
 * de importação de CLIENTES. CPF, CNPJ, telefone e e-mail mascarados no banco.
 *
 * RELEASE: 2026-05-17 v1.0.0 - Versão inicial (Fase 2)
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { createLogger } from '@/lib/logger';

const logger = createLogger('useCustomerImportPreview');

export interface CustomerImportPreviewItem {
  id: string;
  row_index: number;
  customer_type: string | null;
  nome: string | null;
  razao_social: string | null;
  cpf_masked: string | null;
  cnpj_masked: string | null;
  phone_masked: string | null;
  email_masked: string | null;
  cidade: string | null;
  estado: string | null;
  seller_name: string | null;
  status: string;
  validation_errors: unknown;
  error_message: string | null;
}

export function useCustomerImportPreview(jobId: string | null, enabled: boolean) {
  const { currentTenant } = useAuth();
  return useQuery({
    queryKey: ['customer-import-preview', currentTenant?.id, jobId],
    enabled: enabled && !!jobId && !!currentTenant?.id,
    staleTime: 30_000,
    queryFn: async (): Promise<CustomerImportPreviewItem[]> => {
      const { data, error } = await (supabase.rpc as any)('get_customer_import_preview', {
        p_job_id: jobId,
        p_tenant_hint: currentTenant?.id ?? null,
      });
      if (error) {
        logger.error('Erro ao carregar preview de importação de clientes', error);
        throw error;
      }
      return (data ?? []) as CustomerImportPreviewItem[];
    },
  });
}
